import Cookies from 'universal-cookie';
const cookies = new Cookies();

console.log("cookies",cookies.getAll())


export var sid = null;

export function getSid() {
  return sid;
}

export function getStorageSid() {
  return localStorage.getItem("cashplane_sid") || cookies.get("cp2sid") || "";
}

export function setSid(newSid) {
  sid = newSid;
  localStorage.setItem("cashplane_sid", sid);
  cookies.set("cp2sid",newSid,{
    path: "/",
    expires: new Date(Date.now()+1000*60*60*24*7*365)
  })
}

export function clearSid() {
  sid = null
  localStorage.removeItem("cashplane_sid");
  cookies.remove("cp2sid",{path: "/"})
  cookies.remove("PHPSESSID",{path: "/"})
  cookies.remove("sessdata",{path: "/"})  
}

export function setItem(key,value) {
  localStorage.setItem(key, value);
}

export function getItem(key) {
  return localStorage.getItem(key) 
}

export function removeItem(key) {
  localStorage.removeItem(key);
}